import { render, staticRenderFns } from "./ClinicNewAppointment.vue?vue&type=template&id=3ffcc103&scoped=true"
import script from "./ClinicNewAppointment.vue?vue&type=script&lang=js"
export * from "./ClinicNewAppointment.vue?vue&type=script&lang=js"
import style0 from "./ClinicNewAppointment.vue?vue&type=style&index=0&id=3ffcc103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffcc103",
  null
  
)

export default component.exports